<template>
  <div class="fabric-calculation-info">
    <img @click="showModal = true" src="/assets/img/icon/info.svg" alt="icon">

    <template v-if="showModal">
      <div @click="closeModalOnBlur" class="fabric-calculation-info-modal">
        <div class="modal-content">
          <img class="close-icon" @click="showModal = false" src="/assets/img/icon/delete.svg" alt="icon">
          <h2><slot name="title"></slot></h2>
          <div class="modal-content-list">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    closeModalOnBlur(event) {
      if(event.target === event.currentTarget) {
        this.showModal = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fabric-calculation-info {
  all: initial;
  font-family: 'Open Sans';
  >img {
    margin-top: -8px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .fabric-calculation-info-modal {
    position: fixed;
    margin: auto;
    z-index: 1000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .modal-content {
      background-color: white;  
      padding: 20px 0 20px 20px;
      color: black;
      width: 700px;
      overflow: scroll;

      .close-icon {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 15px;
        height: 15px;
        cursor: pointer;
      }

      h2 {
        font-size: 23px;
        color: #000000;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 20px;
      }

      .modal-content-list {
        max-height: 500px;
        padding-right: 20px;
        overflow-y: scroll;
        .calculation-info-container {
          padding: 15px;
          background-color: #f2f2f2;
          border-radius: 5px;
          margin-bottom: 10px;
  
          .title {
            font-size: 16px;
            font-weight: 700;
          }
          .description {
            color: #262626;
            font-size: 13px;
          }
  
          code {
            margin-top: 10px;
            display: block;
            font-family: Consolas, monospace;
            background-color: #f9f9f9;
            border: 1px solid #ccc;
            padding: 10px;
            overflow-x: scroll;
          }
        }
      }

    }
  }
}






</style>